import gsap from "gsap";

const paint = document.querySelector(".paint");
const logo = document.querySelector(".logo");
const containerMv = document.querySelector(".container--mv");
const bgVideo = document.querySelector(".recruit-bg-video");
const textH = document.querySelector(".container--text__h");
const textP = document.querySelector(".container--text__p");

const apngDuration = 3000;

gsap.set(logo, { opacity: 0 });
gsap.set(textH, { opacity: 0 });
gsap.set(textP, { opacity: 0 });

setTimeout(() => {
  const tl = gsap.timeline();

  tl.to(paint, { duration: 1, opacity: 0 }, 0)
    .to(logo, { duration: 1, opacity: 1 }, 0)
    .to(
      containerMv,
      {
        duration: 1,
        opacity: 0,
        onStart: () => {
          if (bgVideo) bgVideo.play(); // 🎬 同時再生
        },
      },
      "+=1"
    )

    // 0.5秒後に textH をフェードイン
    .to(textH, { duration: 1, opacity: 1 }, "+=0.5")

    // 2秒待って textH をフェードアウト
    .to(textH, { duration: 1, opacity: 0 }, "+=2")

    // 3秒待って textP を1.5秒かけてフェードイン
    .to(textP, { duration: 1.5, opacity: 1 }, "+=3");
}, apngDuration);
